export const getActivities = (state) => state.activity?.activities;
export const getRawActivities = (state) => state.activity?.rawActivities;
export const getRawActivitiesCount = (state) => state.activity?.rawActivities.length;
export const getActivitySortField = (state) => state.activity?.sortColumn;
export const getActivitySortDirection = (state) => state.activity?.sortDirection;
export const getActivityFilterFieldValue = (state) => state.activity?.filterValue;
export const getActivityFilters = (state) => state.activity?.filters;